import { createSelector } from "@reduxjs/toolkit";
export const selectOrderAttributesByTarget = createSelector([(state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.checkout) === null || _a === void 0 ? void 0 : _a.orderAttributes.data; }, (_, target) => target], (orderAttributes, target) => {
    const targetOrderAttributes = orderAttributes.filter((orderAttribute) => orderAttribute.placement === target);
    const sortedOrderAttributes = targetOrderAttributes.sort((a, b) => {
        if (typeof a.sort_order === "number" && typeof b.sort_order === "number") {
            return a.sort_order - b.sort_order;
        }
        else {
            return 0;
        }
    });
    return sortedOrderAttributes;
});
//# sourceMappingURL=selectOrderAttributesByTarget.js.map